import { Link } from 'react-router-dom';
import { periodColumn } from 'components/columns';
import type { ListBonus } from 'modules/guarantee/types';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';
import { CompanyTitle } from 'modules/core/company/components';
import { TitleContainer } from 'components/TitleContainer';

export * from './BonusForm';
export * from './RateGroups';

export const columns: ControlledTableColumns<ListBonus> = [
  {
    content: 'Number',
    key: 'number',
    required: true,
    width: 250,
    sortable: true,
    render: ({ id, number }: ListBonus) => <Link to={`${id}`}>{number}</Link>,
  },
  { content: 'Title', key: 'title', sortable: true },
  flexColumn({
    content: 'Partner',
    key: 'partner.title' as any,
    sortable: true,
    cellProps: { className: 'py-1' },
    render: ({ partner }) => <CompanyTitle {...partner} />,
  }),
  {
    cellProps: { className: 'py-1' },
    content: 'Type',
    key: '_type',
    width: 140,
    render: ({ kind, regularity }) => <TitleContainer title={kind} subtitle={regularity} />,
  },
  periodColumn,
];

export const initialValues = {
  title: '',
  number: '',
  partner: null,
  regularity: null,
  date_from: null,
  date_to: null,
  kind: null,
  terms: '',
  notes: '',
  signature_first_name: '',
  signature_last_name: '',
  attachments: [],
  groups: [],
};
